import userInfo from 'hub-http/userInfo';
import BaseApplication from '../BaseApplication';
import routes from '../routes';
export default class HubfulApplication extends BaseApplication {
  // @ts-expect-error ts-migrate(2425) FIXME: Class 'BaseApplication' defines instance member pr... Remove this comment to see the full error message
  loadUserHubInfo() {
    return userInfo();
  }
  loadRoutes() {
    return routes();
  }
}